import React from 'react'
import { Transforms, Editor, Text } from 'slate'
import { useSlate } from 'slate-react'

const Toolbar = ({ isUploading, toggleFormat, insertImage, insertVideo }) => {
  const editor = useSlate()

  return (
    <div className="flex items-center gap-2 p-2 border-b border-zinc-700 bg-zinc-900 sticky top-0 z-10">
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          toggleFormat('bold')
        }}
        className="px-2 py-1 rounded hover:bg-zinc-700 text-white"
      >
        Bold
      </button>
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          toggleFormat('italic')
        }}
        className="px-2 py-1 rounded hover:bg-zinc-700 text-white"
      >
        Italic
      </button>
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          toggleFormat('underline')
        }}
        className="px-2 py-1 rounded hover:bg-zinc-700 text-white"
      >
        Underline
      </button>
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          insertImage()
        }}
        disabled={isUploading}
        className="px-2 py-1 rounded hover:bg-zinc-700 text-white disabled:opacity-50"
      >
        Image
      </button>
      <button
        onMouseDown={(e) => {
          e.preventDefault()
          insertVideo()
        }}
        disabled={isUploading}
        className="px-2 py-1 rounded hover:bg-zinc-700 text-white disabled:opacity-50"
      >
        Video
      </button>
    </div>
  )
}

const isFormatActive = (editor, format) => {
  const [match] = Editor.nodes(editor, {
    match: n => n[format] === true,
    universal: true,
  })
  return !!match
}

export default Toolbar